import type en from "../en/common";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  role_owner: "مالك المتجر",
  role_admin: "مسؤول المتجر",
  role_product_manager: "مدير المنتجات",
  role_order_manager: "مدير الطلبات",
  role_support: "خدمة العملاء",
  role_analyst: "محلل (قراءة فقط)",
  save: "حفظ",
  saving: "جارٍ الحفظ…",
  saveChanges: "حفظ التغييرات",
  saved: "تم الحفظ",
  cancel: "إلغاء",
  close: "إغلاق",
  confirm: "تأكيد",
  delete: "حذف",
  deleting: "جارٍ الحذف…",
  remove: "إزالة",
  edit: "تعديل",
  add: "إضافة",
  create: "إنشاء",
  creating: "جارٍ الإنشاء…",
  back: "رجوع",
  next: "التالي",
  previous: "السابق",
  continue: "متابعة",
  search: "بحث",
  filter: "تصفية",
  clear: "مسح",
  apply: "تطبيق",
  view: "عرض",
  viewAll: "عرض الكل",
  open: "فتح",
  copy: "نسخ",
  copied: "تم النسخ",
  upload: "رفع",
  uploading: "جارٍ الرفع…",
  publish: "نشر",
  publishing: "جارٍ النشر…",
  unpublish: "إلغاء النشر",
  preview: "معاينة",
  undo: "تراجع",
  retry: "إعادة المحاولة",
  yes: "نعم",
  no: "لا",
  none: "لا شيء",
  optional: "اختياري",
  required: "مطلوب",
  loading: "جارٍ التحميل…",
  actions: "إجراءات",
  status: "الحالة",
  name: "الاسم",
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  date: "التاريخ",
  total: "الإجمالي",
  amount: "المبلغ",
  price: "السعر",
  quantity: "الكمية",
  title: "العنوان",
  description: "الوصف",
  type: "النوع",
  createdAt: "تاريخ الإنشاء",
  updatedAt: "آخر تحديث",
  enabled: "مفعّل",
  disabled: "معطّل",
  active: "نشط",
  inactive: "غير نشط",
  draft: "مسودة",
  published: "منشور",
  archived: "مؤرشف",
  live: "منشور",
  pending: "قيد الانتظار",
  all: "الكل",
  page: "الصفحة {page} من {pages}",
  showing: "{from}–{to} من {total}",
  noResults: "لا توجد نتائج",
  somethingWrong: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  notAllowed: "دورك في هذا المتجر لا يسمح بهذا الإجراء.",
  learnMore: "اعرف المزيد",
  unsavedChanges: "لديك تغييرات غير محفوظة.",
  areYouSure: "هل أنت متأكد؟",
  cannotUndo: "لا يمكن التراجع عن هذا الإجراء.",
  testMode: "وضع الاختبار",
  language: "اللغة",
};

export default ar;
